import React, { useState, useEffect } from 'react';
import { productService } from '../services/api';

const Mechanical = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await productService.getProductsByCategory('mechanical');
        setProducts(response.data);
      } catch (err) {
        setError('Failed to load products');
        console.error('Error:', err);
        setProducts([]); // Set empty array as fallback
      } finally {
        setLoading(false);
      }
    };

    fetchProducts();
  }, []);

  const renderListItems = (text) => {
    if (!text) return null;
    return text.split('\n').filter(item => item.trim()).map((item, index) => (
      <li key={index}>{item.trim()}</li>
    ));
  };

  if (loading) {
    return (
      <section className="hero mechanical-hero">
        <div className="hero-overlay"></div>
        <div className="hero-content">
          <h1>Mechanical Shaft Seals</h1>
          <p style={{color: 'var(--primary-color)', fontWeight: '500'}}>Loading...</p>
        </div>
      </section>
    );
  }

  return (
    <>
      {/* Hero Section */}
      <section className="hero mechanical-hero">
        <div className="hero-overlay"></div>
        <div className="hero-content">
          <h1>Mechanical Shaft Seals</h1>
          <p style={{color: 'var(--primary-color)', fontWeight: '500'}}>Providing high-quality mechanical sealing solutions</p>
        </div>
      </section>

      {/* Product Section */}
      <section>
        {products.length > 0 ? (
          products.map((product) => (
            <div key={product.id} className="product-card">
              <div className="product-card-image">
                <img src={product.image} alt={product.name} />
              </div>
              <div className="product-card-details">
                <h2>{product.name}</h2>
                <p>{product.details}</p>
                {product.applications && (
                  <>
                    <h3>Applications</h3>
                    <ul>{renderListItems(product.applications)}</ul>
                  </>
                )}
                {product.operating_range && (
                  <>
                    <h3>Operating Range</h3>
                    <ul>{renderListItems(product.operating_range)}</ul>
                  </>
                )}
                {product.material_of_construction && (
                  <>
                    <h3>Material of Construction</h3>
                    <ul>{renderListItems(product.material_of_construction)}</ul>
                  </>
                )}
                {product.optional_accessories && (
                  <>
                    <h3>Optional Accessories</h3>
                    <ul>{renderListItems(product.optional_accessories)}</ul>
                  </>
                )}
              </div>
            </div>
          ))
        ) : (
          <p>No products available.</p>
        )}
        
        {error && (
          <div style={{color: 'red', padding: '20px'}}>
            {error}
          </div>
        )}
      </section>
    </>
  );
};

export default Mechanical;
